class Header {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.hn-btn').click(function(){
      $('.l-header').toggleClass('is-open');
      $('body').toggleClass('is-fixed');
    });
    $('.anchor-btn').click(function(){
      $('.l-header').removeClass('is-open');
      $('body').removeClass('is-fixed');
    });

    const toggleFixedMenuState = () => {
      const scrollTop = $(window).scrollTop();
      const $anchorContact = $('#anchor-contact');
      const anchorTop = $anchorContact.length ? $anchorContact.offset().top : null;
      const isBeforeContactArea = anchorTop !== null && scrollTop >= anchorTop - 300;

      if (scrollTop > 300 && !isBeforeContactArea) {
        $('.fixd-menu').addClass('is-active');
      } else {
        $('.fixd-menu').removeClass('is-active');
      }
    };

    $(window).on('scroll', toggleFixedMenuState);
    toggleFixedMenuState();
  }
}
